import configureStore from 'common/configureStore'

export const store = configureStore((window as any).__PRELOADED_STATE__)
